import { NgModule } from '@angular/core'
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular'
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core'
import { HttpLink } from 'apollo-angular/http'
import { environment } from '../environments/environment'

const uri = `${environment.graphqlURL}/graphql` // <-- add the URL of the GraphQL server here

// defined a merge function for scienceOrganisations, this seems to prevent a complaint about it, when deleting a scienceOrganisation
export function createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
  return {
    link: httpLink.create({ uri }) as any,
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            scienceOrganisations: {
              merge(_existing, incoming) {
                return incoming
              },
            },
          },
        },
      },
    }),
  }
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
